import { InjectionToken } from '@angular/core';
import { IDbContext } from '../database-context.interface';

export const LOCAL_STORES = ['exam', 'practice'] as const;
export type LocalStore = typeof LOCAL_STORES[number];

export const DATABASE_CONFIG_TOKEN = new InjectionToken<Record<LocalStore, IDbContext>>('__DATABASE_CONFIG__');
